<template>
  <div class="contact fixed-nav">
    <MainHeader :tiles="false" :fixedMenu="true">
      <router-link :to="{ name: 'museum'}">
        <svg>
          <use v-if="selectedTranslation === 'en'" xlink:href="#logoMkSvgEng"></use>
          <use v-else xlink:href="#logoMkSvg"></use>
        </svg>
      </router-link>
    </MainHeader>
    <div class="sections">
      <TextContent :content="htmlContent" :lastPageName="lastPageName"/>
      <MainFooter :content="footerData"/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import TextContent from '@/components/TextContent.vue'

export default {
  name: 'regulations',
  data: function () {
    return {
      htmlContent: ''
    }
  },
  components: {
    MainHeader,
    MainFooter,
    TextContent
  },
  methods: {
    ...mapActions([
      'togglePageNav',
      'resetActiveFilters'
    ]),
    getData () {
      axios.get(`${this.apiPath}regulations`)
        .then(response => {
          this.htmlContent = response.data
        })
        .catch(e => {
          console.error(e)
          // this.errors.push(e)
        })
    }
  },
  computed: {
    ...mapGetters([
      'pageNavOpen',
      'footerData',
      'breakpoint',
      'lastPageName',
      'apiPath',
      'selectedTranslation'
    ]),
    isMobile () {
      return this.breakpoint === 'mobile' || this.breakpoint === 'tablet'
    }
  },
  watch: {
    apiPath (oldVal, newVal) {
      if (oldVal !== newVal) {
        this.getData()
      }
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.resetActiveFilters()
  }
}
</script>

<style scoped lang="scss">
.dark {
  background-color: $bg-dark;
  color: $text-light;
}
</style>
